import {
  isObject,
  isBoolean,
  isDateString,
  isArray,
  isString,
} from 'utils/typeUtils';
import { isNumber } from '../utils/typeUtils';

/**
 * Zeus Token from api
 */
export type OriginalZeusToken = {
  token: string;
  customerId: number;
  createdAt: string;
  expired: boolean;
};

/**
 * Zeus Token from api のユーザ定義型ガード
 */
const isOriginalZeusToken = (arg: unknown): arg is OriginalZeusToken => {
  const a = arg as OriginalZeusToken;

  return (
    isObject(a) &&
    isString(a.token) &&
    isNumber(a.customerId) &&
    isDateString(a.createdAt) &&
    isBoolean(a.expired)
  );
};

/**
 * Zeus Token from api の配列のユーザ定義型ガード
 */
export const isOriginalZeusTokens = (
  arg: unknown,
): arg is OriginalZeusToken[] => {
  const a = arg as OriginalZeusToken[];

  return isObject(a) && isArray<OriginalZeusToken>(a, isOriginalZeusToken);
};
